export const MAKE_PAYMENT_RESPONSE = 'makePaymentResponse';

export const SUBMIT_ADDITIONAL_PAYMENT_DETAILS_RESPONSE = 'submitAdditionalPaymentDetailsResponse';
